import script from "./CustomAlertToast.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomAlertToast.vue?vue&type=script&setup=true&lang=js"

import "./CustomAlertToast.vue?vue&type=style&index=0&id=432f5a6f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432f5a6f"]])

export default __exports__